import React, { useState, useEffect, useRef } from 'react';
import './Invoice.css';

import { PageTitle } from '../../../components';

import { FaHeart, FaHandsHelping, FaMobileAlt, FaBarcode, FaCreditCard, FaFileInvoice, FaCalendarCheck, FaLock, FaEnvelope } from 'react-icons/fa';
import { CiBarcode } from 'react-icons/ci'; // 從 react-icons 庫導入 LINE 圖標
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { MessageModal } from '../../../components';
import { useTokenCheck, getInvoiceDevice, callAddInvoiceDevice, callUpdateInvoiceDevice } from '../../../constants';
import Cookies from 'js-cookie';
import { IoMdOptions } from "react-icons/io";
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';


const Invoice = () => {
  const { nickName, isCanExecute } = useTokenCheck();

  const navigate = useNavigate();

  // #region 需要密碼，返回要前往會員中心

  const location = useLocation();

  // Louis Add new function: 取得QueryParams
  // 當Query String中的變數action=update, 表示為更新資料

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const queryParams = getQueryParams();
  const [action, setAction] = useState("new");//預設註冊

  useEffect(() => {
    if (queryParams["action"] !== undefined && queryParams["action"] !== "") {
      setAction(queryParams["action"]);
    }
  }, [queryParams]);

  // Louis: 完成傳入參數的檢查


  const [isApiHavePassword, setApiHavePassword] = useState(false);//預設註冊

  const [validatePassword, setValidatePassword] = useState('');

  const validatePasswordRef = useRef(null);

  const handleValidatePasswordChange = (e) => {
    const value = e.target.value;
    setValidatePassword(value);
  };

  const validateLength = (value) => {
    return value.trim().length === 0;
  };


  const setNextPage = () => {
    if (action === "update") {
      navigate("/MemberProfile");
    } else if (action === "new") {
      navigate("/MemberProfile");
    }
  };

  // #endregion

  const [invoiceType, setInvoiceType] = useState('');
  const [selfDevice, setSelfDevice] = useState('');
  const [donate, setDonate] = useState('');
  const [email, setEmail] = useState('');

  const selfDeviceRef = useRef(null);
  const donateRef = useRef(null);
  const emailRef = useRef(null);

  const [uniformInvoiceType, setUniformInvoiceType] = useState('Duplicate');//Duplicate 或 Triplicate
  const duplicateRef = useRef(null);
  const triplicateRef = useRef(null);

  const [companyName, setCompanyName] = useState('');
  const [companyID, setCompanyID] = useState('');
  const companyNameRef = useRef(null);
  const companyIDRef = useRef(null);

  const handleSelfDeviceChange = (e) => {
    const value = e.target.value;
    setSelfDevice(value);
  };

  const handleDonateChange = (e) => {
    const value = e.target.value;
    setDonate(value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
  };

  const handleInvoiceTypeChange = (event) => {
    setInvoiceType(event.target.value);
  };

  const handleUniformInvoiceTypeChange = (event) => {
    setUniformInvoiceType(event.target.value);
  };

  const handleCompanyNameTypeChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handleCompanyIDTypeChange = (event) => {
    setCompanyID(event.target.value);
  };

  useEffect(() => {
    if (!isCanExecute) return;
    const chacngeRegistreProcessing = () => {
      if (Cookies.get('cookieConsent') === 'accepted') {

        if (Cookies.get('isRegistreProcessing') === 'true') {
          setApiHavePassword(false);//不需要密碼
        } else {
          setApiHavePassword(true);
          if (action === "new") {
            setAction('update');
          }
        }
      } else {

        // 沒有同意 Cookie 的情況
      }
    }
    getInvoiceDevice().then(payload => {
      const isPayloadValid =
        payload?.status !== undefined &&
        payload?.errorCode !== undefined &&
        payload?.data !== undefined &&
        payload?.errorMessage !== undefined;

      if (isPayloadValid) {
        if (payload.status === 0 && payload.errorCode === '0000') {
          // 處理結果

          if (payload.data == null) {
            // 沒填過 設置預設選中
            selfDeviceRef.current.checked = true;
            setInvoiceType('selfDevice');
          } else if (payload.data != null) {

            if (payload.data.type == 1) {

              selfDeviceRef.current.checked = true;
              setInvoiceType('selfDevice');
              setSelfDevice(payload.data?.deviceID ? payload.data.deviceID : '');

            } else if (payload.data.type == 2) {

              donateRef.current.checked = true;
              setInvoiceType('donate');
              setDonate(payload.data?.deviceID ? payload.data.deviceID : '');

            } else if (payload.data.type == 3) {

              emailRef.current.checked = true;
              setInvoiceType('email');
              setEmail(payload.data?.deviceID ? payload.data.deviceID : '');

              //Duplicate 或 Triplicate
              //"發票類型, 0: 二聯式 1:三聯式"
              if (payload.data?.invoiceType === 0) {
                setUniformInvoiceType('Duplicate');
              }
              if (payload.data?.invoiceType === 1) {
                setUniformInvoiceType('Triplicate');
                setCompanyID(payload.data?.companyID ? payload.data.companyID : '');
                setCompanyName(payload.data?.companyName ? payload.data.companyName : '');
              }

            }
          }

        } else if (payload.status === 1 &&
          (payload.errorCode === '9997' || payload.errorCode === '9998')) {
          //未登入
          let errorMessage = "Token過期，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else if (payload.status === 1 && payload.errorCode === '9996') {
          //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
          let errorMessage = "查無此會員，或發生異常，需要重新登入！";
          MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
        } else {
          let errorMessage = payload.errorMessage;
          MessageModal.alert(errorMessage);
        }
      }
      chacngeRegistreProcessing();
    }).catch(error => {
      console.error('Error during API call:', error);
    });
  }, [isCanExecute]);

  useEffect(() => {

    if (invoiceType === 'email') {
      if (uniformInvoiceType === 'Duplicate') {
        if (duplicateRef) duplicateRef.current.click()
      } else if (uniformInvoiceType === 'Triplicate') {
        if (triplicateRef) triplicateRef.current.click()
      }
    }

  }, [invoiceType]);

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    let formData = {
      "type": '',
      "deviceID": ''
    };

    let type;
    let value;
    let isPass = true;
    if (invoiceType === 'selfDevice') {

      if (validateLength(selfDevice)) {
        const handleError = () => {
          if (selfDeviceRef.current) {
            selfDeviceRef.current.focus();
          }
        };
        MessageModal.alert('請輸入行動載具', handleError);
        isPass = false;
      } else {
        type = 1;
        value = selfDevice;
      }
    } else if (invoiceType === 'donate') {
      type = 2;
      value = donate;
    } else if (invoiceType === 'email') {

      if (validateLength(email)) {
        const handleError = () => {
          if (emailRef.current) {
            emailRef.current.focus();
          }
        };
        MessageModal.alert('請填寫Email', handleError);
        isPass = false;
      } else {

        if (uniformInvoiceType === 'Duplicate') {
          //二聯發票
          type = 3;
          value = email;
          formData.invoiceType = 0; //"發票類型, 0: 二聯式 1:三聯式"
        } else if (uniformInvoiceType === 'Triplicate') {
          //三聯發票
          if (validateLength(companyName)) {
            const handleError = () => {
              if (companyNameRef.current) {
                companyNameRef.current.focus();
              }
            };
            MessageModal.alert('請填寫公司名稱', handleError);
            isPass = false;
          } else if (validateLength(companyID)) {
            const handleError = () => {
              if (companyIDRef.current) {
                companyIDRef.current.focus();
              }
            };
            MessageModal.alert('請填寫統一編號', handleError);
            isPass = false;
          } else {
            type = 3;
            value = email;
            formData.invoiceType = 1; //"發票類型, 0: 二聯式 1:三聯式"
            formData.companyName = companyName;
            formData.companyID = companyID;
          }
        }

      }
    }

    if (!isPass) return;
    formData.type = type;
    formData.deviceID = value;

    if (isApiHavePassword && validateLength(validatePassword)) {
      const handleError = () => {
        setValidatePassword('');
        if (validatePasswordRef.current) {
          validatePasswordRef.current.focus();
        }
      };
      MessageModal.alert('請輸入密碼進行驗證', handleError);
      return;
    }

    if (isApiHavePassword) {

      callUpdateInvoiceDevice(formData, validatePassword).then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果
            setNextPage();
          } else if (payload.status === 1 && payload.errorCode === '9995') {

            const handleError = () => {
              setValidatePassword('');
              if (validatePasswordRef.current) {
                validatePasswordRef.current.focus();
              }
            };

            MessageModal.alert('請確認密碼是否正確', handleError);
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    } else {

      callAddInvoiceDevice(formData).then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果
            setNextPage();
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    }

  };

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />

      {/* Page Title */}
      <PageTitle title={'設定發票載具'} page={'member'} />

      <section className='invoice'>

        {/* Registration Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaFileInvoice /></div>

          {/* Heading for the register form */}
          <h3>發票載具/捐贈</h3>
          {/* Terms and Conditions Checkbox */}
          <div className='terms'>
            <label htmlFor="invoice-device">選擇停⾞費發票載具或是捐贈：</label>
          </div>
          {/* paymentType Input */}
          <div className="input-field">
            <label htmlFor="InvoiceDevice"><FaFileInvoice /></label>
            {/* <input type="text" name="paymentType" placeholder="請選擇" id="paymentType" className="box" /> */}
            {/* <select name="paymentType" id="paymentType" className="box">
            <option value="credit-card">信用卡</option>
            <option value="line-pay">LINE Pay</option>
            </select> */}
            <div className="box">
              <input type="radio" className="radioBox" value="selfDevice" name="InvoiceDevice"
                onChange={handleInvoiceTypeChange}
                ref={selfDeviceRef} />
              <span className="radioIcon" onClick={() => selfDeviceRef.current.click()}><FaMobileAlt /></span>
              <span className="radioItem" onClick={() => selfDeviceRef.current.click()}>行動載具</span>

              <input type="radio" className="radioBox" value="donate" name="InvoiceDevice"
                onChange={handleInvoiceTypeChange}
                ref={donateRef} />
              <span className="radioIcon" onClick={() => donateRef.current.click()}><FaHandsHelping /></span>
              <span className="radioItem" onClick={() => donateRef.current.click()}>捐贈發票</span>

              <br />
              <input type="radio" className="radioBox" value="email" name="InvoiceDevice"
                onChange={handleInvoiceTypeChange}
                ref={emailRef} />
              <span className="radioIcon" onClick={() => emailRef.current.click()}><FaEnvelope /></span>
              <span className="radioItem" onClick={() => emailRef.current.click()}>Email</span>
            </div>
          </div>

          <div className={`input-field-invoice" ${invoiceType === 'selfDevice' ? '' : 'hidden'}`}>
            {/* CreditcardNo Input */}
            <div className="input-field">
              <label htmlFor="DeviceNo"><FaBarcode /></label>
              <input type="text" name="DeviceNo" placeholder="請輸入載具條碼" id="DeviceNo" className="box"
                value={selfDevice} onChange={handleSelfDeviceChange} />
              <div className="fieldNoticeIcon"><CiBarcode /></div>
            </div>
          </div>

          <div className={`input-field-invoice" ${invoiceType === 'donate' ? '' : 'hidden'}`}>
            {/* cardExpire Input */}
            <div className="input-field">
              <label htmlFor="giveCode"><FaHeart /></label>
              <input type="text" name="giveCode" placeholder="請輸入愛心碼" id="giveCode" className="box"
                value={donate} onChange={handleDonateChange} />
            </div>
            <div className='notice'>
              <label >請填寫愛⼼碼，如果不填寫將由系統⾃動幫您配對</label>
            </div>
          </div>

          <div className={`input-field-invoice" ${invoiceType === 'email' ? '' : 'hidden'}`}>

            <div className="input-field">
              <label htmlFor="email"><FaEnvelope /></label>
              <input type="email" name="email" placeholder="請填寫Email" id="email" className="box"
                value={email} onChange={handleEmailChange} />
            </div>

            <div className="input-field">
              <label><IoMdOptions /></label>

              <div className="box">
                <input type="radio" className="radioBox" value="Duplicate" name="UniformInvoiceType"
                  style={{ marginTop: '0' }}
                  onChange={handleUniformInvoiceTypeChange}
                  ref={duplicateRef} />
                <span className="radioIcon" onClick={() => duplicateRef.current.click()}></span>
                <span className="radioItem" onClick={() => duplicateRef.current.click()}>二聯發票</span>

                <input type="radio" className="radioBox" value="Triplicate" name="UniformInvoiceType"
                  style={{ marginTop: '0' }}
                  onChange={handleUniformInvoiceTypeChange}
                  ref={triplicateRef} />
                <span className="radioIcon" onClick={() => triplicateRef.current.click()}></span>
                <span className="radioItem" onClick={() => triplicateRef.current.click()}>三聯發票</span>

              </div>
            </div>

            <div className={`input-field-uniformInvoice" ${uniformInvoiceType === 'Triplicate' ? '' : 'hidden'}`}>
              <div className="input-field">
                <label htmlFor="companyName"><IoMdOptions /></label>
                <input type="companyName" name="companyName" placeholder="請填寫公司名稱" id="companyName" className="box"
                  value={companyName} onChange={handleCompanyNameTypeChange}
                  ref={companyNameRef} />
              </div>
              <div className="input-field">
                <label htmlFor="companyID"><IoMdOptions /></label>
                <input type="companyID" name="companyID" placeholder="請填寫統一編號" id="companyID" className="box"
                  value={companyID} onChange={handleCompanyIDTypeChange}
                  ref={companyIDRef}
                  pattern="\d*"
                  maxLength="10" />
              </div>

            </div>
          </div>

          {action === "update" &&
            <div className="validatePassword">
              <div className='terms'>
                <h4>密碼:</h4>
                <label>修改資料需輸入舊密碼進行驗證</label>
              </div>
              <div className="input-field">
                <label htmlFor="validate-password"><FaLock /></label>
                <input type="password" name="validate-password" placeholder="如果需要修改資料，需填入密碼。" id="validate-password" className="box"
                  maxLength="16" value={validatePassword} onChange={handleValidatePasswordChange} ref={validatePasswordRef} />
              </div>
              <div className='notice'>
                <label >為了保障您的資料安全性，更新需要驗證密碼。
                </label>
              </div>
            </div>
          }

          <button name='submit' id='submit' className='btn'>填寫完成</button>
          {action === "new" && <Link to="/MemberProfile" ><button name='ignore' id='ignore' className='btn'>暫時不設定</button></Link>}
          {action === "update" && <Link to="/MemberProfile"><button name='ignore' id='ignore' className='btn'>回到會員中心</button></Link>}

        </form>

      </section>
    </>
  );
}

export default Invoice;